module.exports = __webpack_public_path__ + "static/media/venue-2.a745b7c8.jpg";